import {RelationLevel} from 'src/openapi/admin/models/RelationLevel';

export const SECTION_NAME = 'Presets';
export const NO_PRESETS_TITLE =
    'There are currently no presets. ' +
    'Please use the "Create a Preset" button to create a new preset.';

export const NO_PRESETS_DESCRIPTION =
    'If you do not have access to the "Create a Preset" button on this page, ' +
    'please reach out to the PB Admin team to request an entitlement update.';


export const COLUMNS = {
    TITLE: 'title',
    DESCRIPTION: 'description',
    GRANT: 'grant',
    STATUS: 'status',
    RESTRICTION: 'restriction',
    LEVEL: 'level',
};

export const RELATION_LEVEL_CAPTIONS: Record<string, string> = {
    [RelationLevel.PARENT]: 'Account',
    [RelationLevel.CHILD]: 'User',
};

export const HEADERS = {
    [COLUMNS.TITLE]: 'Role/Resource',
    [COLUMNS.DESCRIPTION]: 'Description',
    [COLUMNS.GRANT]: 'Entitlement Grant',
    [COLUMNS.STATUS]: 'Status',
    [COLUMNS.RESTRICTION]: 'Restriction',
    [COLUMNS.LEVEL]: 'Level',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.TITLE,
        fixed: true,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.DESCRIPTION,
        fixed: false,
        defaultWidth: 450,
        minWidth: 400,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.GRANT,
        fixed: false,
        defaultWidth: 400,
        minWidth: 350,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.STATUS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 400,
    },
    {
        columnId: COLUMNS.RESTRICTION,
        fixed: false,
        defaultWidth: 260,
        minWidth: 260,
        maxWidth: 500,
    },
    {
        columnId: COLUMNS.LEVEL,
        fixed: false,
        defaultWidth: 150,
        minWidth: 100,
        maxWidth: 200,
    },
];
